const MISSING_ADDRESS_VALUE = "N/A";

/** ShipmentHound fills missing pickup address parts with "N/A"; treat those, and blanks, as absent. */
export const presentAddressValue = (value?: string): string | undefined => {
  const trimmed = value?.trim();
  return trimmed && trimmed !== MISSING_ADDRESS_VALUE ? trimmed : undefined;
};
